(() => {
 'use strict';
 if (window.quranGlowV3Ready) return;
 window.quranGlowV3Ready = true;
 const instances = new WeakMap();
 function init(root) {
  if (!root || instances.has(root)) return;
  const lifecycle = new AbortController();
  const cleanup = [];
  const whatsappNumber = (root.dataset.whatsappNumber || '').replace(/\D/g,'');
  const byId = id => root.querySelector('#'+CSS.escape(id));
  function on(target,type,callback,options={}) { if (target) target.addEventListener(type,callback,{...options,signal:lifecycle.signal}); }
  instances.set(root,()=>{lifecycle.abort();cleanup.forEach(fn=>fn());document.body.classList.remove('keyboard-active');instances.delete(root);});
const messaging = (() => {
  const countryPicker = root.querySelector('select[data-qg-country]');
  const countryControl = root.querySelector('[data-qg-country-control]');
  const countryTrigger = root.querySelector('[data-qg-country-trigger]');
  const countryChoices = [...root.querySelectorAll('[data-qg-country-choice]')];
  const countryMenuMode = window.matchMedia('(max-width:800px), (min-width:601px) and (max-width:1024px) and (max-height:600px)');
  function placeCountryControl() {
    const destination = root.querySelector(countryMenuMode.matches ? '[data-qg-country-mobile]' : '[data-qg-country-desktop]');
    if (countryControl.parentElement === destination) return;
    const heldFocus = countryControl.contains(document.activeElement);
    countryControl.open = false;
    destination.append(countryControl);
    if (heldFocus) (countryMenuMode.matches && root.querySelector('#mobile-nav').hidden ? root.querySelector('.menu-toggle') : countryTrigger).focus({preventScroll:true});
  }
  placeCountryControl();
  on(countryMenuMode,'change',placeCountryControl);
  const routeStatus = root.querySelector('[data-qg-route-status]');
  const dock = root.querySelector('.booking-dock-inner');
  const dialog = root.querySelector('[data-qg-draft-dialog]');
  const draftText = root.querySelector('[data-qg-draft-text]');
  const draftHelp = root.querySelector('[data-qg-draft-help]');
  const draftStatus = root.querySelector('[data-qg-draft-status]');
  const openApp = root.querySelector('[data-qg-open-app]');
  const draftTitle = root.querySelector('[data-qg-draft-title]');
  const labels = {whatsapp:'WhatsApp', messages:'Messages', messenger:'Messenger'};
  const countries = {US:'United States',GB:'United Kingdom',CA:'Canada',AU:'Australia',SA:'Saudi Arabia',AE:'United Arab Emirates',QA:'Qatar',KW:'Kuwait',BH:'Bahrain',OTHER:'International'};
  const userAgent = navigator.userAgent || '';
  // Apple documents sms: links for iOS. A desktop-user-agent iPad is still iPadOS.
  // A Mac alone does not demonstrate that a compatible Messages handler exists.
  const appleMobile = /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1);
  function cleanNumber(value) {
    const source=String(value || '').trim();
    if(!/^\+?[\d\s().-]+$/.test(source))return '';
    const digits = source.replace(/\D/g,'');
    return /^[1-9]\d{6,14}$/.test(digits) ? digits : '';
  }
  function validMessenger(value) {
    if (!value) return '';
    try {
      const url = new URL(value);
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return '';
      const host = url.hostname.toLowerCase();
      let page = '';
      if (host === 'm.me' || host === 'www.m.me') page = url.pathname.replace(/^\/|\/$/g,'');
      else if (host === 'facebook.com' || host === 'www.facebook.com') {
        if (url.pathname === '/profile.php' && /^\d+$/.test(url.searchParams.get('id') || '')) page = url.searchParams.get('id');
        else page = url.pathname.replace(/^\/|\/$/g,'');
        if (/^(login|login.php|share|sharer|sharer.php|dialog|settings|messages|groups|events|watch|marketplace|privacy|help|home.php)$/i.test(page)) return '';
      } else if (host === 'messenger.com' || host === 'www.messenger.com') {
        const match = url.pathname.match(/^\/t\/([A-Za-z0-9._-]+)\/?$/);
        if (match) page = match[1];
      }
      return /^[A-Za-z0-9._-]+$/.test(page) ? 'https://m.me/' + encodeURIComponent(page) : '';
    } catch (_) { return ''; }
  }
  const waNumber = cleanNumber(root.dataset.whatsappNumber);
  const messagesNumber = cleanNumber(root.dataset.messagesNumber);
  const messengerUrl = root.dataset.enableMessenger !== 'false' ? validMessenger(root.dataset.messengerUrl) : '';
  const available = {
    whatsapp: Boolean(waNumber),
    messages: root.dataset.enableMessages !== 'false' && appleMobile && Boolean(messagesNumber),
    messenger: Boolean(messengerUrl)
  };
  function countryCode(value) {
    const code = String(value || '').toUpperCase();
    return code === 'UK' ? 'GB' : Object.hasOwn(countries,code) ? code : 'OTHER';
  }
  const autoCountry = countryCode(root.dataset.country);
  let override = 'AUTO';
  try { const saved = localStorage.getItem('qg-contact-country'); if (saved === 'AUTO' || Object.hasOwn(countries,saved)) override = saved; } catch (_) {}
  let country = override === 'AUTO' ? autoCountry : override;
  let primary = 'whatsapp';
  let currentDraft = '';
  let lastDraftTrigger = null;
  const sourceLinks = [...root.querySelectorAll('[data-qg-primary]')].map(link => {
    const url = new URL(link.href,location.href);
    return {link,label:link.textContent.trim(),aria:link.getAttribute('aria-label'),message:url.searchParams.get('text') || ''};
  });
  const formHelps = [...root.querySelectorAll('.booking-footnote[id]')];
  // Keep existing editable FAQ content while making channel-independent guidance neutral.
  root.querySelectorAll('.faq-list details p').forEach(paragraph=>{
    const walker=document.createTreeWalker(paragraph,NodeFilter.SHOW_TEXT);
    let node;
    while((node=walker.nextNode()))node.textContent=node.textContent.replace(/on WhatsApp/g,'by message').replace(/via WhatsApp/g,'by message').replace(/through WhatsApp/g,'by message').replace(/WhatsApp us/g,'Message us').replace(/your WhatsApp conversation/g,'your message');
  });
  const faqAnswers = [...root.querySelectorAll('.faq-list details')]
    .filter(detail => /how do i book a free trial/i.test(detail.querySelector('summary')?.textContent || ''))
    .map(detail => ({node:detail.querySelector('p'),original:detail.querySelector('p')?.innerHTML || ''}));
  function channelIcon(channel) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('class','icon');svg.setAttribute('aria-hidden','true');
    const use = document.createElementNS('http://www.w3.org/2000/svg','use');
    use.setAttribute('href',channel === 'whatsapp' ? '#i-wa' : channel === 'messages' ? '#i-messages' : '#i-messenger');
    svg.append(use);return svg;
  }
  function setButton(link,channel,label) {
    const span = document.createElement('span');span.textContent = label;
    link.replaceChildren(channelIcon(channel),span);
    link.dataset.qgActiveChannel = channel;
  }
  function destination(channel,message='') {
    if (channel === 'messages') return 'sms:+' + messagesNumber;
    if (channel === 'messenger') return messengerUrl;
    return 'https://wa.me/' + waNumber + (message ? '?text=' + encodeURIComponent(message) : '');
  }
  function setTarget(link,channel,message='') {
    link.href = destination(channel,message);
    if (channel === 'messages') { link.removeAttribute('target');link.removeAttribute('rel'); }
    else { link.target='_blank';link.rel='noopener noreferrer'; }
  }
  function showDraft(message,trigger) {
    if(!primary)return;
    currentDraft = message;
    if (trigger) lastDraftTrigger = trigger;
    draftText.value = message;
    draftTitle.textContent = 'Your trial message';
    draftHelp.textContent = primary === 'whatsapp'
      ? 'Open WhatsApp to review and send these details.'
      : 'Copy your details, open ' + labels[primary] + ', then paste and send your message.';
    draftStatus.textContent = '';
    setButton(openApp,primary,'Open ' + labels[primary]);
    setTarget(openApp,primary,message);
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else { dialog.setAttribute('open',''); dialog.querySelector('[data-qg-close-draft]').focus(); }
    }
  }
  function closeDraft() {
    if (typeof dialog.close === 'function') dialog.close();else dialog.removeAttribute('open');
    lastDraftTrigger?.focus({preventScroll:true});
  }
  function renderRouting() {
    country = override === 'AUTO' ? autoCountry : override;
    const usFirst = country === 'US' && appleMobile && root.dataset.usMessagesFirst !== 'false';
    const order = (usFirst ? ['messages','messenger','whatsapp'] : ['whatsapp','messenger','messages']).filter(key=>available[key]);
    primary = order[0] || null;
    root.dataset.qgCountry = country;
    root.dataset.qgPrimaryChannel = primary || 'unavailable';
    const back = dock.querySelector('.back-to-top');
    for (const channel of ['whatsapp','messenger','messages']) {
      const link = dock.querySelector('[data-qg-channel="'+channel+'"]');
      link.hidden = !available[channel];
      if (available[channel]) {setTarget(link,channel);setButton(link,channel,labels[channel]);}
    }
    for (const channel of order) dock.insertBefore(dock.querySelector('[data-qg-channel="'+channel+'"]'),back);
    dock.style.setProperty('--qg-channel-count',String(Math.max(1,order.length)));
    dock.dataset.qgCount = String(order.length);
    let unavailable=dock.querySelector('[data-qg-unavailable]');
    if(!unavailable){unavailable=document.createElement('span');unavailable.className='qg-contact-unavailable';unavailable.dataset.qgUnavailable='';unavailable.textContent='Messaging unavailable';dock.insertBefore(unavailable,back);}
    unavailable.hidden=Boolean(primary);
    sourceLinks.forEach(({link,label,aria,message}) => {
      if(!primary){link.href='#contact';link.removeAttribute('target');link.setAttribute('aria-disabled','true');setButton(link,'whatsapp','Contact unavailable');return;}
      link.removeAttribute('aria-disabled');
      const changedLabel = label.replace(/WhatsApp/g,labels[primary]);
      setButton(link,primary,changedLabel);
      setTarget(link,primary,message);
      if (aria) link.setAttribute('aria-label',aria.replace(/WhatsApp/g,labels[primary]));
    });
    root.querySelectorAll('.quick-form [type="submit"]').forEach(button=>{button.disabled=!primary;setButton(button,primary||'whatsapp',!primary?'Contact unavailable':primary==='whatsapp'?'Book Free Trial Class':'Prepare Trial Message');});
    formHelps.forEach(help=>{
      let note=help.querySelector('[data-qg-form-channel-note]');
      if (!note) {
        [...help.childNodes].filter(node=>node.nodeType===Node.TEXT_NODE).forEach(node=>node.remove());
        note=document.createElement('span');note.dataset.qgFormChannelNote='';help.append(document.createTextNode(' '),note);
      }
      note.textContent=!primary?'Messaging is temporarily unavailable. Please try again later.':primary==='whatsapp'?'Opens a WhatsApp draft for you to send.':'Prepare your details to copy into '+labels[primary]+'.';
    });
    faqAnswers.forEach(({node,original})=>{
      if(node)node.innerHTML=!primary?original.replace('It opens a WhatsApp message for you to send.','Messaging is temporarily unavailable. Please try again later.'):primary==='whatsapp'?original:original.replace('It opens a WhatsApp message for you to send.','Your details are prepared to copy into '+labels[primary]+' before opening the app.');
    });
    if (dialog.open) {if(primary)showDraft(currentDraft);else closeDraft();}
    routeStatus.textContent=primary?'Contact options for '+countries[country]+'. Main option: '+labels[primary]+'.':'Messaging is temporarily unavailable.';
    const flag = Object.hasOwn({US:1,GB:1,CA:1,AU:1,SA:1,AE:1,QA:1,KW:1,BH:1},country) ? country.toLowerCase() : 'globe';
    countryControl.querySelector('[data-qg-country-icon]').setAttribute('href','#qg-country-'+flag);
    countryControl.querySelector('[data-qg-country-current]').textContent=countries[country];
    countryTrigger.setAttribute('aria-label','Country: '+countries[country]+'. Change country and prices');
    countryChoices.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.qgCountryChoice===override)));
    root.dispatchEvent(new CustomEvent('qg:country-change',{detail:{country}}));
  }
  countryPicker.querySelector('[value="AUTO"]').textContent='Auto: '+(autoCountry==='OTHER'?'Other':autoCountry==='GB'?'UK':autoCountry);
  countryPicker.value=override;
  countryControl.hidden=false;
  countryControl.querySelector('[data-qg-country-auto]').textContent='Automatic · '+countries[autoCountry];
  countryChoices.forEach(button=>on(button,'click',()=>{
    countryPicker.value=button.dataset.qgCountryChoice;
    countryPicker.dispatchEvent(new Event('change',{bubbles:true}));
    countryControl.open=false;
    countryTrigger.focus({preventScroll:true});
  }));
  on(countryControl,'keydown',event=>{
    if(event.key==='Escape' && countryControl.open){event.preventDefault();event.stopPropagation();countryControl.open=false;countryTrigger.focus({preventScroll:true});}
    else if(event.key==='ArrowDown' && event.target===countryTrigger){event.preventDefault();countryControl.open=true;(countryChoices.find(button=>button.getAttribute('aria-pressed')==='true')||countryChoices[0]).focus();}
  });
  on(document,'click',event=>{if(!countryControl.contains(event.target))countryControl.open=false;});
  on(root.querySelector('.menu-toggle'),'click',()=>{countryControl.open=false;});
  cleanup.push(()=>{countryControl.open=false;});
  on(countryPicker,'change',()=>{
    override=countryPicker.value==='AUTO'?'AUTO':countryCode(countryPicker.value);
    try {localStorage.setItem('qg-contact-country',override);} catch (_) {}
    renderRouting();
  });
  sourceLinks.forEach(({link,message})=>on(link,'click',event=>{
    if(primary==='whatsapp')return;
    event.preventDefault();
    if(!primary)return;
    showDraft(message || 'Assalamualaikum, I would like to book a '+root.dataset.trialDays+'-day free trial with '+root.dataset.brand+'. Please help me choose a class time.',link);
  }));
  on(root.querySelector('[data-qg-copy]'),'click',async()=>{
    try {
      if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(draftText.value);
      if(!lifecycle.signal.aborted)draftStatus.textContent='Copied. Open '+labels[primary]+', then paste and send.';
    } catch (_) {
      draftText.focus();draftText.select();
      draftStatus.textContent='Select and copy the message below, then open '+labels[primary]+'.';
    }
  });
  on(root.querySelector('[data-qg-close-draft]'),'click',closeDraft);
  on(dialog,'click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDraft();}});
  cleanup.push(()=>{if(dialog.open){if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');}});
  renderRouting();
  return {
    sendBookingDraft(message,status,trigger) {
      if(!primary){status.textContent='Messaging is temporarily unavailable. Please try again later.';return;}
      if(primary!=='whatsapp') {
        status.textContent='Your details are ready to copy into '+labels[primary]+'.';
        showDraft(message,trigger);return;
      }
      const link=document.createElement('a');setTarget(link,'whatsapp',message);link.click();
      status.textContent='Your WhatsApp draft is ready. Send it there to request your trial.';
    }
  };
})();

{

  'use strict';
  const mobile = window.matchMedia('(max-width:600px)');
  const coursePages = window.matchMedia('(max-width:1000px)');
  const cardMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
  const header = root.querySelector('.header-inner');
  const headerShell = root.querySelector('.site-header');
  const dock = root.querySelector('.mobile-dock');
  const announcement = root.querySelector('.topbar');
  const pricing = byId('pricing');
  const sections = [...root.querySelectorAll('.qg-section-card')];
  let cards = [];
  let layoutFrame = 0, navigationFrame = 0, viewportFrame = 0, wheelTimer = 0;
  let cardsEnabled = false, headerHeight = 0, dockHeight = 0;
  let navigationTarget = null, wheelBurst = false, wheelDelta = 0, lastWheelAt = 0, touch = null;
  let screenHeight = 0, viewportWidth = window.innerWidth, alignedCard = null;
  let lastNavigationAt = 0, lastWheelStepAt = 0, lastWheelMagnitude = 0, lastWheelDirection = 0;
  function activeCardFor(element) {
    if (!element) return null;
    return cards.find(card => card === element || card.contains(element) || element.contains(card)) || null;
  }
  function refreshCards() {
    cards.forEach(card => card.removeAttribute('data-scroll-card'));
    cards = sections.flatMap(section => section.id === 'courses' && coursePages.matches ? [...section.querySelectorAll('.qg-course-page')] : [section]);
    cards.forEach(card => card.setAttribute('data-scroll-card',''));
    alignedCard = activeCardFor(alignedCard);
    if (navigationTarget) {
      const element = activeCardFor(navigationTarget.element);
      navigationTarget = element ? {element,index:cards.indexOf(element)} : null;
    }
  }
  refreshCards();
  function markCardReady(element) {
    if (!element || element.classList.contains('qg-card-ready')) return;
    element.classList.add('qg-card-ready', 'is-visible');
    element.closest('.qg-section-card')?.classList.add('qg-card-ready');
    element.querySelectorAll('.reveal').forEach(node => node.classList.add('is-visible'));
  }
  function readyAllCards() {
    if (restCardsTimer) { clearTimeout(restCardsTimer); restCardsTimer = 0; }
    document.documentElement.classList.add('qg-cards-ready');
    sections.forEach(markCardReady);
    root.querySelectorAll('.qg-course-page').forEach(markCardReady);
  }
  let restCardsTimer = 0;
  function revealSequentialCards(destination) {
    if (!destination?.element) return;
    if (window.Shopify?.designMode || !mobile.matches) { readyAllCards(); return; }
    const index = Number.isInteger(destination.index) ? destination.index : cards.indexOf(destination.element);
    if (index < 1) return;
    markCardReady(cards[1]);
    markCardReady(destination.element);
    if (!document.documentElement.classList.contains('qg-cards-ready') && !restCardsTimer) {
      restCardsTimer = setTimeout(readyAllCards, 180);
    }
  }
  function initCardReadiness() {
    if (window.Shopify?.designMode || !mobile.matches) { readyAllCards(); return; }
    markCardReady(cards[0] || sections[0]);
    const hash = (location.hash || '').replace(/^#/, '');
    if (!hash || hash === 'home') return;
    const card = activeCardFor(byId(hash));
    if (!card) return;
    const index = cards.indexOf(card);
    revealSequentialCards({element: card, index: index < 0 ? 1 : index});
  }
  function layoutTop(element) {
    let top = 0;
    for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
    return top;
  }
  function updateCardLayout() {
    cardsEnabled = root.dataset.mobileLayout !== 'continuous';
    document.documentElement.classList.toggle('qg-card-pages', cardsEnabled);
    document.documentElement.classList.toggle('qg-mobile-cards', cardsEnabled && mobile.matches);
    headerHeight = Math.ceil(header.getBoundingClientRect().bottom - headerShell.getBoundingClientRect().top) + 1;
    dockHeight = Math.ceil(dock.getBoundingClientRect().height) || dockHeight;
    document.documentElement.style.setProperty('--qg-mobile-header', headerHeight + 'px');
    if (dockHeight) document.documentElement.style.setProperty('--qg-mobile-dock', dockHeight + 'px');
    document.documentElement.style.setProperty('--qg-mobile-announcement', Math.ceil(announcement.getBoundingClientRect().height) + 'px');
  }
  function scheduleCardLayout() {
    cancelAnimationFrame(layoutFrame);
    layoutFrame = requestAnimationFrame(updateCardLayout);
  }
  function gesturesAllowed(target) {
    return cardsEnabled && !cardMotion.matches && !window.Shopify?.designMode && !root.querySelector('[data-qg-draft-dialog][open]') &&
      !document.documentElement.classList.contains('qg-form-focused') &&
      (window.visualViewport?.scale || 1) <= 1.01 &&
      root.querySelector('.menu-toggle').getAttribute('aria-expanded') !== 'true' &&
      !target.closest('input,textarea,select,[contenteditable],.site-header,.mobile-dock');
  }
  function cardBounds() {
    return cards.map((element,index) => {
      const top = layoutTop(element);
      const max = Math.max(0,document.documentElement.scrollHeight - window.innerHeight);
      return {element, index, top, bottom:top + element.offsetHeight, start:index === 0 ? 0 : Math.min(max,Math.max(0,top - headerHeight - 12))};
    });
  }
  function cardDestination(position, direction) {
    const usable = (screenHeight || window.innerHeight) - headerHeight - dockHeight - 24;
    const viewTop = position + headerHeight + 12;
    const viewBottom = position + (screenHeight || window.innerHeight) - dockHeight - 12;
    const bounds = cardBounds();
    // Include the spaces between cards. Longer content remains readable within
    // its own section, then the next gesture advances to the adjacent card.
    const index = bounds.findIndex((card,index) => position >= card.start - 3 &&
      (index < bounds.length - 1 ? position < bounds[index + 1].start - 3 : viewTop < card.bottom + 30));
    if (index < 0) return null;
    const current = bounds[index];
    const fits = current.bottom - current.top <= usable + 4;
    if (direction > 0) {
      if (!fits && viewBottom < current.bottom - 12) return null;
      return bounds[Math.min(index + 1,bounds.length - 1)];
    }
    if (position > current.start + 28) return fits ? current : null;
    return index > 0 ? bounds[index - 1] : bounds[0];
  }
  function moveToCard(destination, direct = false) {
    revealSequentialCards(destination);
    [destination.element,...destination.element.querySelectorAll('.reveal')].forEach(element => element.classList.add('is-visible'));
    cancelAnimationFrame(navigationFrame);
    navigationTarget = destination;
    alignedCard = null;
    const from = window.scrollY, started = performance.now();
    const duration = cardMotion.matches ? 0 : direct ? 420 : started - lastNavigationAt < 650 ? 220 : 380;
    lastNavigationAt = started;
    function animate(now) {
      const progress = duration ? Math.max(0,Math.min(1,(now - started) / duration)) : 1;
      const current = cardBounds().find(card => card.element === activeCardFor(destination.element));
      window.scrollTo({top:from + (current.start - from) * (1 - Math.pow(1 - progress,3)),behavior:'instant'});
      if (progress < 1) navigationFrame = requestAnimationFrame(animate);
      else { navigationFrame = 0; navigationTarget = null; trackAlignment(); }
    }
    navigationFrame = requestAnimationFrame(animate);
  }
  function keepWheelBurst() {
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelBurst = false; wheelDelta = 0; },160);
  }
  on(window, 'wheel', event => {
    if (!gesturesAllowed(event.target) || event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.cancelable) return;
    const now = performance.now();
    const direction = Math.sign(event.deltaY);
    if (!direction) return;
    const magnitude = Math.abs(event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1));
    if (!wheelBurst && now - lastWheelAt > 160) wheelDelta = 0;
    const freshGesture = !wheelBurst || direction !== lastWheelDirection || now - lastWheelAt > 120 ||
      (magnitude >= 80 && magnitude >= lastWheelMagnitude * .95 && now - lastWheelStepAt > 100);
    lastWheelAt = now; lastWheelMagnitude = magnitude; lastWheelDirection = direction;
    if (wheelBurst && !freshGesture) { event.preventDefault(); keepWheelBurst(); return; }
    const destination = cardDestination(navigationTarget ? cardBounds()[navigationTarget.index].start : window.scrollY,direction);
    if (!destination) { alignedCard = null; return; }
    // Consume even sub-threshold wheel movement, rather than leaving a card
    // partially scrolled while waiting for a clear navigation gesture.
    event.preventDefault();
    if (wheelBurst || Math.sign(wheelDelta) !== direction) wheelDelta = 0;
    wheelDelta += event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1);
    if (Math.abs(wheelDelta) < 18) return;
    wheelBurst = true; lastWheelStepAt = now; keepWheelBurst(); moveToCard(destination);
  },{passive:false});
  // One touch gesture advances one card. A second distinct gesture can retarget
  // an in-flight transition, so deliberate quick swipes never hit a time lock.
  // Fields, pinch zoom, horizontal gestures and oversized content stay native.
  on(window, 'touchstart', event => {
    touch = event.touches.length === 1 && gesturesAllowed(event.target)
      ? {x:event.touches[0].clientX,y:event.touches[0].clientY,position:window.scrollY,target:event.target,intent:null,reference:navigationTarget?.element,destination:null} : null;
  },{passive:true});
  on(window, 'touchmove', event => {
    if (event.touches.length !== 1 || !touch || !gesturesAllowed(touch.target)) { touch = null; return; }
    const dx = event.touches[0].clientX - touch.x, dy = touch.y - event.touches[0].clientY;
    if (!touch.intent) {
      if (Math.max(Math.abs(dx),Math.abs(dy)) < 4) return;
      if (Math.abs(dx) > Math.abs(dy) * .7) { touch.intent = 'native'; return; }
      const base = touch.reference ? cardBounds().find(card => card.element === touch.reference).start : touch.position;
      touch.destination = cardDestination(base,Math.sign(dy));
      touch.intent = touch.destination ? 'card' : 'native';
      if (touch.intent === 'native') alignedCard = null;
    }
    if (touch.intent === 'card' && event.cancelable) event.preventDefault();
  },{passive:false});
  on(window, 'touchend', event => {
    const start = touch; touch = null;
    if (!start || !event.changedTouches.length || !gesturesAllowed(start.target)) return;
    const dx = event.changedTouches[0].clientX - start.x, dy = start.y - event.changedTouches[0].clientY;
    if (Math.abs(dy) < 18 || Math.abs(dx) > Math.abs(dy) * .7 || start.intent === 'native') return;
    const base = start.reference ? cardBounds().find(card => card.element === start.reference).start : start.position;
    const destination = cardDestination(base,Math.sign(dy));
    if (destination) moveToCard(destination);
  },{passive:true});
  on(window, 'touchcancel', () => { touch = null; },{passive:true});
  function trackAlignment() {
    if (navigationTarget || !cardsEnabled) return;
    if (viewportFrame) {
      const held = cardBounds().find(card => card.element === alignedCard);
      if (held && Math.abs(window.scrollY - held.start) > 32) alignedCard = null;
      return;
    }
    // Native hash links may land a few pixels from the exact card start while
    // its reveal transform finishes. Still recognise that card on a resize.
    alignedCard = cardBounds().find(card => Math.abs(window.scrollY - card.start) < 16)?.element || null;
  }
  function resizeViewport() {
    // Browser address/tool bars change the visible height. Interpolate the
    // shared height variable, keeping an already aligned card in place as all
    // sections resize. Do not treat the keyboard or pinch zoom as a card resize.
    if (document.documentElement.classList.contains('qg-form-focused') || (window.visualViewport?.scale || 1) > 1.01) return;
    const widthChanged = viewportWidth !== window.innerWidth;
    viewportWidth = window.innerWidth;
    updateCardLayout();
    cancelAnimationFrame(viewportFrame); viewportFrame = 0;
    if (!cardsEnabled) { document.documentElement.style.removeProperty('--qg-screen-height'); pricing?.classList.remove('pricing-compact'); pricing?.style.removeProperty('--qg-pricing-height'); screenHeight = 0; alignedCard = null; return; }
    const nextHeight = Math.round(window.visualViewport?.height || window.innerHeight);
    const fromHeight = screenHeight || nextHeight;
    const holdCard = navigationTarget ? null : alignedCard;
    const holdOffset = holdCard ? window.scrollY - cardBounds().find(card => card.element === holdCard).start : 0;
    const started = performance.now();
    const duration = !screenHeight || widthChanged || cardMotion.matches ? 0 : 240;
    function fit(now) {
      const progress = duration ? Math.max(0,Math.min(1,(now - started) / duration)) : 1;
      screenHeight = fromHeight + (nextHeight - fromHeight) * (1 - Math.pow(1 - progress,3));
      document.documentElement.style.setProperty('--qg-screen-height',screenHeight + 'px');
      // Fit all four plans above the dock while the browser's address bar is open.
      // Use available height, independently of content height, to avoid resize loops.
      // On shrink, fit pricing immediately so the moving browser toolbar cannot
      // cover a button while the other section heights finish their transition.
      const pricingHeight = Math.max(0, Math.min(screenHeight, nextHeight) - headerHeight - dockHeight - 24);
      pricing?.style.setProperty('--qg-pricing-height', pricingHeight + 'px');
      pricing?.classList.toggle('pricing-compact', mobile.matches && pricingHeight < 580);
      if (holdCard && alignedCard === holdCard && !navigationTarget && !touch) {
        const current = cardBounds().find(card => card.element === holdCard);
        window.scrollTo({top:current.start + holdOffset * Math.pow(1 - progress,3),behavior:'instant'});
      }
      if (progress < 1) viewportFrame = requestAnimationFrame(fit);
      else { viewportFrame = 0; trackAlignment(); }
    }
    if (Math.abs(nextHeight - fromHeight) < 1 || !duration) fit(started + duration);
    else viewportFrame = requestAnimationFrame(fit);
  }
  function resetNavigation() {
    cancelAnimationFrame(navigationFrame);
    const destination = navigationTarget;
    navigationTarget = null; touch = null; wheelBurst = false; wheelDelta = 0;
    clearTimeout(wheelTimer);
    updateCardLayout();
    if (destination && cardsEnabled) {
      const updated = cardBounds().find(card => card.element === activeCardFor(destination.element));
      window.scrollTo({top:updated.start,behavior:'instant'});
    }
    resizeViewport();
  }
  let cardResizeObserver;
  if ('ResizeObserver' in window) {
    cardResizeObserver = new ResizeObserver(scheduleCardLayout);
    [header,headerShell,dock,announcement,...cards].forEach(element => cardResizeObserver.observe(element));
  }
  on(mobile, 'change', resetNavigation);
  on(coursePages, 'change', () => {
    refreshCards(); resetNavigation();
    if (cardResizeObserver) { cardResizeObserver.disconnect(); [header,headerShell,dock,announcement,...cards].forEach(element => cardResizeObserver.observe(element)); }
  });
  on(cardMotion, 'change', resetNavigation);
  on(window, 'resize', resizeViewport);
  if (window.visualViewport) on(window.visualViewport, 'resize', resizeViewport);
  on(window, 'scroll', trackAlignment,{passive:true});
  on(document, 'click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link) {
      alignedCard = null; touch = null; navigationTarget = null;
      cancelAnimationFrame(navigationFrame);
      const target = byId(link.hash.slice(1));
      const card = cardBounds().find(item => item.element === activeCardFor(target));
      if (card && cardsEnabled && !window.Shopify?.designMode) {
        event.preventDefault();
        history.replaceState(null,'',link.hash);
        moveToCard(card,true);
      }
    }
  });
  on(document, 'keydown', event => {
    if (!gesturesAllowed(event.target) || event.target.closest('a,button,summary') || event.altKey || event.ctrlKey || event.metaKey) return;
    const direction = ['PageDown','ArrowDown',' '].includes(event.key) ? (event.shiftKey ? -1 : 1) : ['PageUp','ArrowUp'].includes(event.key) ? -1 : 0;
    if (!direction) return;
    const destination = cardDestination(navigationTarget ? cardBounds()[navigationTarget.index].start : window.scrollY,direction);
    if (destination) { event.preventDefault(); moveToCard(destination); }
  });
  root.querySelectorAll('.faq-section details').forEach(detail => on(detail, 'toggle', () => {
    if (detail.open) detail.closest('.faq-list').querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
  }));
  on(window, 'pageshow', () => { alignedCard = null; resetNavigation(); trackAlignment(); });
  on(document, 'focusin', event => { if (event.target.matches('input,textarea,select')) { cancelAnimationFrame(navigationFrame); navigationTarget = null; touch = null; document.documentElement.classList.add('qg-form-focused'); } });
  on(document, 'focusout', event => { if (event.target.matches('input,textarea,select')) document.documentElement.classList.remove('qg-form-focused'); });
  updateCardLayout();
  resizeViewport();
  initCardReadiness();
  on(window, 'beforeprint', readyAllCards);

cleanup.push(() => { cardResizeObserver?.disconnect(); cancelAnimationFrame(layoutFrame); cancelAnimationFrame(navigationFrame); cancelAnimationFrame(viewportFrame); clearTimeout(wheelTimer); clearTimeout(restCardsTimer); document.documentElement.classList.remove('qg-card-pages','qg-mobile-cards','qg-form-focused','qg-cards-ready'); ['--qg-screen-height','--qg-mobile-header','--qg-mobile-dock','--qg-mobile-announcement'].forEach(name => document.documentElement.style.removeProperty(name)); pricing?.style.removeProperty('--qg-pricing-height'); pricing?.classList.remove('pricing-compact'); cards.forEach(card=>card.removeAttribute('data-scroll-card')); });

}
{

  'use strict';
  const menuButton = root.querySelector('.menu-toggle');
  const menu = byId('mobile-nav');
  function closeMenu() {
    menu.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open navigation menu');
  }
  menuButton.hidden = false;
  on(menuButton, 'click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menu.hidden = !open;
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
  });
  on(menu, 'click', event => { if (event.target.closest('a')) closeMenu(); });
  on(document, 'keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) { closeMenu(); menuButton.focus(); }
  });
  on(document, 'click', event => { if (!menu.hidden && !event.target.closest('.site-header')) closeMenu(); });
  on(window.matchMedia('(min-width:801px)'), 'change', event => { if (event.matches) closeMenu(); });
  root.querySelectorAll('.quick-form').forEach(form => {
  const nameInput = form.querySelector('[data-field="name"]');
  const contactInput = form.querySelector('[data-field="contact"]');
  const status = form.closest('.booking-card').querySelector('.form-status');
  [nameInput, contactInput].forEach(input => on(input, 'input', () => { input.setCustomValidity(''); status.textContent = ''; }));
  on(form, 'submit', event => {
    event.preventDefault();
    const name = nameInput.value.trim();
    const contact = contactInput.value.trim();
    if (!name) { nameInput.setCustomValidity('Please enter your name.'); nameInput.reportValidity(); return; }
    const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact);
    const phone = /^[+()\d\s.-]+$/.test(contact) && contact.replace(/\D/g, '').length >= 7 && contact.replace(/\D/g, '').length <= 15;
    if (!email && !phone) { contactInput.setCustomValidity('Enter a valid email address or phone number, including country code if possible.'); contactInput.reportValidity(); return; }
    const message = ['Assalamualaikum! I would like to book a ' + root.dataset.trialDays + '-day free trial class with ' + root.dataset.brand + '.', '', 'Name: ' + name, 'Email or phone: ' + contact, '', 'Please help me choose a suitable teacher and class time.'].join('\n');
    messaging.sendBookingDraft(message, status, event.submitter || form.querySelector('[type=submit]'));
  });
  });
  byId('year').textContent = new Date().getFullYear();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const regularReveals = [...root.querySelectorAll('.reveal')];
  const sectionReveals = [...root.querySelectorAll('main>section:not(.hero)')];
  const elements = [...regularReveals, ...sectionReveals];
  const mobileRevealMedia = window.matchMedia('(max-width:600px)');
  let observer;
  function revealAll() { if (observer) observer.disconnect(); elements.forEach(element => element.classList.remove('reveal-pending')); }
  function prepareReveals() {
    revealAll();
    if (window.Shopify?.designMode || motion.matches || !('IntersectionObserver' in window)) return;
    if (mobileRevealMedia.matches) return;
    try {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
          else entry.target.classList.add('reveal-pending');
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -16px 0px' });
      const targets = document.documentElement.classList.contains('qg-mobile-cards') ? sectionReveals : regularReveals;
      targets.forEach(element => { element.classList.remove('is-visible'); observer.observe(element); });
    } catch (_) { revealAll(); }
  }
  prepareReveals();
  on(motion, 'change', prepareReveals);
  on(mobileRevealMedia, 'change', prepareReveals);
  on(window, 'beforeprint', revealAll);
  on(window, 'pageshow', event => { if (event.persisted) revealAll(); });
  on(document, 'click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const target = byId(link.getAttribute('href').slice(1));
    if (!target) return;
    [target, ...target.querySelectorAll('.reveal'), target.closest('.reveal')].filter(Boolean).forEach(element => element.classList.add('is-visible'));
  });

cleanup.push(revealAll);

}
{

  'use strict';
  const note = byId('currency-status');
  const prices = [...root.querySelectorAll('.monthly-price')];
  const currencyLabel = root.querySelector('[data-qg-currency-label]');
  // Frankfurter reference rates verified on 29 September 2026. Providers publish
  // on different dates, so each quote keeps its own verified reference date.
  let rates = {USD:1, GBP:.75356, CAD:1.4139, AUD:1.424, SAR:3.75, AED:3.6725, QAR:3.64, KWD:.30812, BHD:.376};
  let dates = {GBP:'2026-09-29',CAD:'2026-09-29',AUD:'2026-09-29',SAR:'2026-09-28',AED:'2026-09-28',QAR:'2026-09-28',KWD:'2026-09-28',BHD:'2026-09-28'};
  const quotes = ['GBP','CAD','AUD','SAR','AED','QAR','KWD','BHD'];
  const labels = {USD:'US$', GBP:'£', CAD:'C$', AUD:'A$', SAR:'SAR ', AED:'AED ', QAR:'QAR ', KWD:'KWD ', BHD:'BHD '};
  function currencyForCountry(country) {
    return ({GB:'GBP',UK:'GBP',CA:'CAD',AU:'AUD',SA:'SAR',AE:'AED',QA:'QAR',KW:'KWD',BH:'BHD'})[String(country || '').toUpperCase()] || 'USD';
  }
  let selected = currencyForCountry(root.dataset.qgCountry || root.dataset.country);
  let refreshPromise;
  let refreshState = 'reference';
  function render() {
    const dateLabel = selected==='USD' ? '' : new Intl.DateTimeFormat('en-GB', {day:'numeric', month:'short', year:'numeric', timeZone:'UTC'}).format(new Date(dates[selected] + 'T12:00:00Z'));
    root.dataset.qgCurrency=selected;
    if(currencyLabel)currencyLabel.textContent='Prices in '+selected;
    prices.forEach(element => {
      const displayed = String(Math.round(Number(element.dataset.usd) * rates[selected]));
      element.textContent = (selected === 'USD' ? '' : '≈ ') + labels[selected] + displayed + ' / month';
      element.title = selected === 'USD' ? 'Monthly fee in US dollars' : 'Estimated conversion · reference: ' + dateLabel + (refreshState === 'failed' ? ' · saved rate; live update unavailable' : '') + '. Final amount confirmed when you enrol.';
    });
    note.textContent = selected === 'USD' ? 'Prices updated to USD.' : 'Estimated prices updated to ' + selected + '. ' + (refreshState === 'loading' ? 'Checking current rates.' : refreshState === 'failed' ? 'Live update unavailable; saved reference rates used.' : 'Reference rates dated ' + dateLabel + '.');
  }
  async function refresh() {
    refreshState = 'loading';
    const controller = new AbortController();
lifecycle.signal.addEventListener('abort', () => controller.abort(), {once:true});
    const timeout = setTimeout(() => controller.abort(), 7000);
    try {
      const response = await fetch('https://api.frankfurter.dev/v2/rates?base=USD&quotes=GBP,CAD,AUD,SAR,AED,QAR,KWD,BHD', {signal:controller.signal, credentials:'omit'});
      if (!response.ok) throw new Error('Rates unavailable');
      const data = await response.json();
      if (!Array.isArray(data)) throw new Error('Invalid rates');
      const checked = {USD:1}, checkedDates = {};
      for (const currency of quotes) {
        const entry = data.find(row => row.base === 'USD' && row.quote === currency);
        if (!entry || !Number.isFinite(entry.rate) || entry.rate <= 0 || entry.rate > 100 || !/^\d{4}-\d{2}-\d{2}$/.test(entry.date) || !Number.isFinite(Date.parse(entry.date)) || entry.date < dates[currency]) throw new Error('Incomplete or outdated rates');
        checked[currency] = entry.rate; checkedDates[currency] = entry.date;
      }
      rates = checked; dates = checkedDates; refreshState = 'updated';
    } catch (_) { refreshState = 'failed'; }
    finally { clearTimeout(timeout); if (!lifecycle.signal.aborted) render(); }
  }
  function selectCurrency(currency) {
    if (!Object.hasOwn(labels,currency)) return;
    selected = currency;
    render();
    if (selected !== 'USD' && !refreshPromise) { refreshPromise = refresh(); render(); }
  }
  selectCurrency(selected);
  note.textContent = '';
  on(root, 'qg:country-change', event => selectCurrency(currencyForCountry(event.detail?.country || root.dataset.qgCountry)));
  root.querySelectorAll('.faq-list details p').forEach(paragraph=>{
    const walker=document.createTreeWalker(paragraph,NodeFilter.SHOW_TEXT);
    let node;
    while((node=walker.nextNode()))node.textContent=node.textContent.replace('GBP, CAD and AUD figures are estimates converted from the USD monthly fees.','Converted prices are estimates based on USD monthly fees. Choose your country from the navigation menu to see your currency.');
  });
  on(document, 'focusin', event => { if (event.target.matches('input')) document.body.classList.add('keyboard-active'); });
  on(document, 'focusout', event => { if (event.target.matches('input')) document.body.classList.remove('keyboard-active'); });

}
 }
 function findRoot(target) { return target.matches?.('[data-quran-glow]') ? target : target.querySelector?.('[data-quran-glow]'); }
 function start() { document.querySelectorAll('[data-quran-glow]').forEach(init); }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
 document.addEventListener('shopify:section:load',event=>init(findRoot(event.target)));
 document.addEventListener('shopify:section:unload',event=>{const root=findRoot(event.target);if(root)instances.get(root)?.();});
 document.addEventListener('shopify:block:select',event=>{
   const block=event.target;
   if (!block.closest('[data-quran-glow]')) return;
   block.classList.add('is-visible','qg-editor-selected');
   block.closest('.reveal')?.classList.add('is-visible');
   if(block.matches('details')) block.open=true;
   block.scrollIntoView({block:'center',behavior:'auto'});
 });
 document.addEventListener('shopify:block:deselect',event=>event.target.classList.remove('qg-editor-selected'));
})();
